import * as React from "react";
import { SVGProps } from "react";
const SvgLogoGoogleSheets = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="logo-google-sheets_svg__a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={2}
      y={0}
      width={14}
      height={18}
    >
      <path
        d="M10.182 0H3.227A1.23 1.23 0 0 0 2 1.227v15.546A1.23 1.23 0 0 0 3.227 18h10.637a1.23 1.23 0 0 0 1.227-1.227V4.909L10.18 0Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#logo-google-sheets_svg__a)">
      <path
        d="M10.182 0H3.227A1.23 1.23 0 0 0 2 1.227v15.546A1.23 1.23 0 0 0 3.227 18h10.637a1.23 1.23 0 0 0 1.227-1.227V4.909l-2.864-2.045L10.182 0Z"
        fill="#0F9D58"
      />
    </g>
    <mask
      id="logo-google-sheets_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={2}
      y={0}
      width={14}
      height={18}
    >
      <path
        d="M10.182 0H3.227A1.23 1.23 0 0 0 2 1.227v15.546A1.23 1.23 0 0 0 3.227 18h10.637a1.23 1.23 0 0 0 1.227-1.227V4.909L10.18 0Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#logo-google-sheets_svg__b)">
      <path
        d="M5.273 8.796v5.931h6.545V8.796H5.273Zm2.863 5.113H6.091v-1.022h2.045v1.022Zm0-1.636H6.091V11.25h2.045v1.023Zm0-1.636H6.091V9.614h2.045v1.023ZM11 13.909H8.955v-1.022H11v1.022Zm0-1.636H8.955V11.25H11v1.023Zm0-1.636H8.955V9.614H11v1.023Z"
        fill="#F1F1F1"
      />
    </g>
    <mask
      id="logo-google-sheets_svg__c"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={2}
      y={0}
      width={14}
      height={18}
    >
      <path
        d="M10.182 0H3.227A1.23 1.23 0 0 0 2 1.227v15.546A1.23 1.23 0 0 0 3.227 18h10.637a1.23 1.23 0 0 0 1.227-1.227V4.909L10.18 0Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#logo-google-sheets_svg__c)">
      <path
        d="m10.54 4.55 4.55 4.55V4.908l-4.55-.359Z"
        fill="url(#logo-google-sheets_svg__d)"
      />
    </g>
    <mask
      id="logo-google-sheets_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={2}
      y={0}
      width={14}
      height={18}
    >
      <path
        d="M10.182 0H3.227A1.23 1.23 0 0 0 2 1.227v15.546A1.23 1.23 0 0 0 3.227 18h10.637a1.23 1.23 0 0 0 1.227-1.227V4.909L10.18 0Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#logo-google-sheets_svg__e)">
      <path
        d="M10.182 0v3.682c0 .678.55 1.227 1.227 1.227h3.682L10.181 0Z"
        fill="#87CEAC"
      />
    </g>
    <mask
      id="logo-google-sheets_svg__f"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={2}
      y={0}
      width={14}
      height={18}
    >
      <path
        d="M10.182 0H3.227A1.23 1.23 0 0 0 2 1.227v15.546A1.23 1.23 0 0 0 3.227 18h10.637a1.23 1.23 0 0 0 1.227-1.227V4.909L10.18 0Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#logo-google-sheets_svg__f)">
      <path
        d="M3.227 0A1.23 1.23 0 0 0 2 1.227v.103A1.23 1.23 0 0 1 3.227.102h6.955V0H3.227Z"
        fill="#fff"
        fillOpacity={0.2}
      />
    </g>
    <mask
      id="logo-google-sheets_svg__g"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={2}
      y={0}
      width={14}
      height={18}
    >
      <path
        d="M10.182 0H3.227A1.23 1.23 0 0 0 2 1.227v15.546A1.23 1.23 0 0 0 3.227 18h10.637a1.23 1.23 0 0 0 1.227-1.227V4.909L10.18 0Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#logo-google-sheets_svg__g)">
      <path
        d="M13.864 17.898H3.227A1.23 1.23 0 0 1 2 16.67v.102A1.23 1.23 0 0 0 3.227 18h10.637a1.23 1.23 0 0 0 1.227-1.227v-.102a1.23 1.23 0 0 1-1.227 1.227Z"
        fill="#263238"
        fillOpacity={0.2}
      />
    </g>
    <mask
      id="logo-google-sheets_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={2}
      y={0}
      width={14}
      height={18}
    >
      <path
        d="M10.182 0H3.227A1.23 1.23 0 0 0 2 1.227v15.546A1.23 1.23 0 0 0 3.227 18h10.637a1.23 1.23 0 0 0 1.227-1.227V4.909L10.18 0Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#logo-google-sheets_svg__h)">
      <path
        d="M11.41 4.91c-.679 0-1.228-.55-1.228-1.228v.102c0 .678.55 1.228 1.227 1.228h3.682v-.103h-3.682Z"
        fill="#263238"
        fillOpacity={0.1}
      />
    </g>
    <path
      d="M10.182 0H3.227A1.23 1.23 0 0 0 2 1.227v15.546A1.23 1.23 0 0 0 3.227 18h10.637a1.23 1.23 0 0 0 1.227-1.227V4.909L10.18 0Z"
      fill="url(#logo-google-sheets_svg__i)"
    />
    <defs>
      <radialGradient
        id="logo-google-sheets_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(2.415 .358) scale(21.1089)"
      >
        <stop stopColor="#fff" stopOpacity={0.1} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="logo-google-sheets_svg__d"
        x1={12.816}
        y1={4.941}
        x2={12.816}
        y2={9.1}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#263238" stopOpacity={0.2} />
        <stop offset={1} stopColor="#263238" stopOpacity={0.02} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgLogoGoogleSheets;
